'use client'
import './styles.scss'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

export const Input = ({ label, ...rest }: InputProps) => {
  return (
    <label className="input-label">
      <span>{label}</span>
      <input placeholder=" " {...rest} />
    </label>
  )
}
